<template>
  <v-bottom-sheet max-width="620" v-model="rowDailog" persistent inset v-if="selectedRow">
    <v-card class="day-detail-sheet">
      <v-card-title class="day-detail-header">
        <div>
          <span class="sheet-eyebrow">Shift details</span>
          <strong v-if="employeeAccess && employeeAccess.report.showHours">
            {{ secondsToHms(selectedRow.totalInSeconds) }}
          </strong>
          <strong v-else>Time entries</strong>
          <span class="entry-summary">
            {{ selectedRow.row.length }} {{ selectedRow.row.length === 1 ? "entry" : "entries" }}
          </span>
        </div>
        <v-btn class="sheet-close" icon @click="close" aria-label="Close shift details">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <div class="touch-view-container-detail">
        <template v-for="(item, index) in selectedRow.row">
          <article :key="index" :class="['shift-card', item.clockOutTime ? 'is-complete' : 'is-open']">
            <header class="shift-card-header">
              <div class="shift-status">
                <v-icon>{{ item.clockOutTime ? "mdi-check-circle-outline" : "mdi-progress-clock" }}</v-icon>
                <div>
                  <span>{{ item.clockOutTime ? "Completed shift" : "Open shift" }}</span>
                  <strong v-if="employeeAccess && employeeAccess.report.showHours">
                    <template v-if="item.clockOutTime">{{ secondsToHms(item.shiftDuration.totalInSeconds) }}</template>
                    <template v-else>Currently clocked in</template>
                  </strong>
                </div>
              </div>
              <div class="shift-actions">
                <Edit v-if="employeeAccess && employeeAccess.timeClock.edit" @submit="dataSave"
                  @error="dataError" :editRow="item" />
                <v-btn v-if="employeeAccess && employeeAccess.timeClock.delete" class="delete-entry" icon
                  @click.stop.prevent="deleteTime(item)" aria-label="Delete time entry">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </div>
            </header>

            <div class="shift-timeline">
              <button type="button" class="time-point is-in" @click.stop.prevent="openImage('in', item)">
                <span class="time-point-label"><v-icon small>mdi-login</v-icon>Clock in</span>
                <v-avatar tile size="82" class="entry-photo">
                  <v-img aspect-ratio="1" height="82" width="82" v-if="item.clockInUrl"
                    :src="item.clockInUrl" :lazy-src="item.clockInUrl">
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                          </v-row>
                        </template>
                  </v-img>
                  <v-img v-else aspect-ratio="1" height="82" width="82" src="@/assets/images/user.jpeg"></v-img>
                </v-avatar>
                <strong>{{ item.clockInTime | moment("h:mm A") }}</strong>
                <small>{{ item.clockInTime | moment("MMM D, YYYY") }}</small>
                <span class="entry-method">
                  <v-icon small>{{ item.clockInFingerprint ? "mdi-fingerprint" : "mdi-dialpad" }}</v-icon>
                  {{ item.clockInFingerprint ? "Fingerprint" : "PIN" }}
                </span>
              </button>

              <div class="timeline-connector">
                <span></span>
                <v-icon small>mdi-arrow-right</v-icon>
                <span></span>
              </div>

              <button type="button" :class="['time-point', 'is-out', { 'is-pending': !item.clockOutTime }]"
                @click.stop.prevent="openImage('out', item)">
                <span class="time-point-label"><v-icon small>mdi-logout</v-icon>Clock out</span>
                <v-avatar tile size="82" class="entry-photo">
                  <v-img aspect-ratio="1" height="82" width="82" v-if="item.clockOutUrl"
                    :src="item.clockOutUrl" :lazy-src="item.clockOutUrl">
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                          </v-row>
                        </template>
                  </v-img>
                  <v-img v-else aspect-ratio="1" height="82" width="82" src="@/assets/images/user.jpeg"></v-img>
                </v-avatar>
                <template v-if="item.clockOutTime">
                  <strong>{{ item.clockOutTime | moment("h:mm A") }}</strong>
                  <small>{{ item.clockOutTime | moment("MMM D, YYYY") }}</small>
                  <span class="entry-method">
                    <v-icon small>{{ item.clockOutFingerprint ? "mdi-fingerprint" : "mdi-dialpad" }}</v-icon>
                    {{ item.clockOutFingerprint ? "Fingerprint" : "PIN" }}
                  </span>
                </template>
                <template v-else>
                  <strong>Still working</strong>
                  <small>No clock-out recorded</small>
                </template>
              </button>
            </div>
          </article>
        </template>
      </div>
    </v-card>
    <v-dialog v-model="imageView" v-if="selectedImage" width="500" class="pa-5">
      <v-card class="image-view-card rounded-xl">
        <v-card-title primary-title>
          <span v-if="selectedStatus === 'in'">Clock In</span>
          <span v-else>Clock Out</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="imageView = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-5">
          <div v-if="selectedStatus === 'in'" class="text-center">
            <strong>{{ selectedImage.clockInTime | moment("LL LT") }}</strong>
          </div>
          <div v-else class="text-center">
            <strong>{{ selectedImage.clockOutTime | moment("LL LT") }}</strong>
          </div>
        </v-card-text>
        <v-card-text>
          <v-img
            v-if="selectedStatus === 'in'"
            :src="selectedImage.clockInUrl"
            :lazy-src="selectedImage.clockInUrl"
            aspect-ratio="1"
            class="grey lighten-2"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>

          <v-img
            v-else
            :src="selectedImage.clockOutUrl"
            :lazy-src="selectedImage.clockOutUrl"
            aspect-ratio="1"
            class="grey lighten-2"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-bottom-sheet>
</template>

<script>
import { SwipeList, SwipeOut } from "vue-swipe-actions";
import Edit from "@/modules/Reports/components/Edit.vue";
import "vue-swipe-actions/dist/vue-swipe-actions.css";
import timeClockService from "@/modules/TimeClock/service";
import { mapGetters } from "vuex";

export default {
  name: "day-detail",
  props: ["selectedRow", "dialog", "workingHours"],
  data() {
    return {
      selectedImage: null,
      selectedStatus: null,
      imageView: false,
      rowDailog: false,
    };
  },
  components: {
    SwipeOut,
    SwipeList,
    Edit,
  },
  watch: {
    dialog(val) {
      this.rowDailog = val;
      console.log("selectedRow", this.selectedRow);
    },
  },
  computed: {
    ...mapGetters("employee", ["employeeAccess"]),
  },
  methods: {
    openImage(status, obj) {
      this.selectedImage = obj;
      this.selectedStatus = status;
      if (status === "in" && obj.clockInUrl) {
        this.imageView = true;
      }
      if (status === "out" && obj.clockOutUrl) {
        this.imageView = true;
      }
    },

    deleteTime(row) {
      return this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            timeClockService.delete(row.id).then((response) => {
              if (response.data) {
                this.$toast.success("Entry was deleted", { timeout: 2000 });
                // this.$swal.fire("Deleted!", "Entry was deleted.", "success");
                this.$emit("submit");
              }
            });
          }
        })
        .catch((error) => {
          this.$toast.error(error.data ? error.data.message : "Error", {
            timeout: 2000,
          });

          console.log(error);
        });
    },
    dataError(e) {
      console.log("errdataErrordataErroror", e);
      this.$toast.error("Can't save entry, check date and time", {
        timeout: 2000,
      });
      // this.snackbar.text = "Can't save entry, check date and time";
      // this.snackbar.status = true;
      // this.snackbar.color = "error";
    },
    close() {
      this.$emit("close");
    },
    dataSave() {
      // this.snackbar.text = "Time entry saved";
      // this.snackbar.status = true;
      // this.snackbar.color = "black";
      this.$toast.success("Time entry saved", { timeout: 2000 });
      this.$emit("submit");
    },
    secondsToHms(d) {
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor((d % 3600) / 60);
      var s = Math.floor((d % 3600) % 60);

      // console.log('AndDown', this.$vuetify.breakpoint.xsOnly)

      var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
      var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
      var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";

      if (this.$vuetify.breakpoint.xsOnly) {
        hDisplay = h > 0 ? h + " h, " : "";
        mDisplay = m > 0 ? m + " m, " : "";
        sDisplay = s > 0 ? s + " s " : "";
      }

      return hDisplay + mDisplay + sDisplay;
    },
  },
};
</script>

<style scoped>
.day-detail-sheet {
  background: var(--v-surface-base) !important;
  border: 1px solid var(--v-border-base);
  border-radius: 22px 22px 0 0 !important;
  color: var(--v-textPrimary-base);
  max-height: min(78vh, 720px);
  overflow: hidden;
  width: 100%;
}

.day-detail-header {
  align-items: flex-start;
  border-bottom: 1px solid var(--v-border-base);
  display: flex;
  padding: 20px 22px 16px;
}

.day-detail-header > div:first-child {
  min-width: 0;
}

.sheet-eyebrow,
.day-detail-header strong,
.entry-summary {
  display: block;
}

.sheet-eyebrow {
  color: var(--v-textSecondary-base);
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.day-detail-header strong {
  color: var(--v-textPrimary-base);
  font-size: 1.25rem;
  line-height: 1.35;
  margin-top: 2px;
}

.entry-summary {
  color: var(--v-textSecondary-base);
  font-size: 0.75rem;
  margin-top: 3px;
}

.sheet-close {
  background: var(--v-surfaceMuted-base);
  color: var(--v-textPrimary-base);
  margin-left: auto;
}

.touch-view-container-detail {
  max-height: calc(min(78vh, 720px) - 100px);
  padding: 16px;
  width: 100%;
  overflow: auto;
}

.shift-card {
  background: var(--v-surfaceMuted-base);
  border: 1px solid var(--v-border-base);
  border-radius: 16px;
  margin-bottom: 12px;
  overflow: hidden;
}

.shift-card-header,
.shift-status,
.shift-actions {
  align-items: center;
  display: flex;
}

.shift-card-header {
  border-bottom: 1px solid var(--v-border-base);
  justify-content: space-between;
  min-height: 62px;
  padding: 10px 12px 10px 16px;
}

.shift-status {
  gap: 9px;
}

.shift-status > .v-icon {
  color: #31c989;
}

.shift-card.is-open .shift-status > .v-icon {
  color: #f0aa45;
}

.shift-status span,
.shift-status strong {
  display: block;
}

.shift-status span {
  color: var(--v-textSecondary-base);
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
}

.shift-status strong {
  color: var(--v-textPrimary-base);
  font-size: 0.86rem;
}

.shift-actions {
  gap: 2px;
}

.shift-actions ::v-deep .v-btn .v-icon {
  color: var(--v-textSecondary-base) !important;
}

.delete-entry {
  color: #f36b75 !important;
}

.delete-entry .v-icon {
  color: inherit !important;
}

.shift-timeline {
  align-items: center;
  display: grid;
  gap: 10px;
  grid-template-columns: minmax(0, 1fr) 46px minmax(0, 1fr);
  padding: 18px;
}

.time-point {
  align-items: center;
  appearance: none;
  background: transparent;
  border: 0;
  color: var(--v-textPrimary-base);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font: inherit;
  min-width: 0;
  padding: 0;
  text-align: center;
}

.time-point-label {
  align-items: center;
  border-radius: 999px;
  display: flex;
  font-size: 0.7rem;
  font-weight: 800;
  gap: 4px;
  margin-bottom: 9px;
  padding: 4px 9px;
  text-transform: uppercase;
}

.time-point.is-in .time-point-label {
  background: rgba(45, 190, 126, 0.13);
  color: #31c989;
}

.time-point.is-out .time-point-label {
  background: rgba(244, 83, 94, 0.12);
  color: #f36b75;
}

.time-point-label .v-icon {
  color: inherit;
}

.entry-photo {
  border: 2px solid var(--v-border-base);
  border-radius: 14px !important;
  margin-bottom: 9px;
  overflow: hidden;
}

.time-point strong {
  color: var(--v-textPrimary-base);
  font-size: 0.95rem;
}

.time-point small {
  color: var(--v-textSecondary-base);
  font-size: 0.68rem;
  margin-top: 2px;
}

.entry-method {
  align-items: center;
  color: var(--v-textSecondary-base);
  display: flex;
  font-size: 0.65rem;
  gap: 3px;
  margin-top: 7px;
}

.entry-method .v-icon {
  color: var(--v-primary-base);
}

.time-point.is-pending {
  opacity: 0.7;
}

.timeline-connector {
  align-items: center;
  color: var(--v-textSecondary-base);
  display: flex;
}

.timeline-connector span {
  border-top: 1px dashed var(--v-border-base);
  flex: 1;
}

.timeline-connector .v-icon {
  color: var(--v-textSecondary-base);
}

.image-view-card {
  background: var(--v-surface-base) !important;
  color: var(--v-textPrimary-base);
}

@media (max-width: 600px) {
  .day-detail-sheet {
    border-radius: 20px 20px 0 0 !important;
    max-height: 88vh;
  }

  .day-detail-header {
    padding: 16px;
  }

  .day-detail-header strong {
    font-size: 1.05rem;
  }

  .touch-view-container-detail {
    max-height: calc(88vh - 90px);
    padding: 12px;
  }

  .shift-timeline {
    gap: 5px;
    grid-template-columns: minmax(0, 1fr) 28px minmax(0, 1fr);
    padding: 14px 8px 16px;
  }

  .entry-photo {
    height: 72px !important;
    width: 72px !important;
  }

  .time-point strong {
    font-size: 0.82rem;
  }

  .entry-method {
    font-size: 0.6rem;
  }
}
</style>
